import Vue from 'vue'
import LuaEngine from './lua'

Vue.use(LuaEngine)

export default new LuaEngine()
